const setUser = (user: any) => {
    localStorage.setItem("user",JSON.stringify(user));
}

const getUser = () => {
    let user: any = localStorage.getItem("user")
    if(user != "undefined"){
        return JSON.parse(user);
    }else{
        return null;
    }
}

const setAuthToken = (token: any) => {
    localStorage.setItem("authToken",token)
}

const getAuthToken = () => {
    return localStorage.getItem("authToken")
}

const setManualCount = (availableCount: any) => {
    localStorage.setItem('availableCount',availableCount)
}

const getManualCount = () => {
    return localStorage.getItem("availableCount")
}

const setMissingCount = (manualCount: any) => {
    localStorage.setItem('manualCount',manualCount)
}

const getMissingCount = () => {
    return localStorage.getItem("manualCount")
}
export {
    setUser,
    getUser,
    setAuthToken,
    getAuthToken,
    setManualCount,
    getManualCount,
    setMissingCount,
    getMissingCount
}